import { useEffect, useState } from 'react';

/** `full`: reveals + animated connectors. `subtle`: reveals only. `none`: everything static. */
export type MotionMode = 'full' | 'subtle' | 'none';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(REDUCED_MOTION_QUERY).matches
        : false;

/** Derives the motion level from the OS "reduce motion" setting and follows it live. */
export const useMotionMode = (): MotionMode => {
    const [reduced, setReduced] = useState(prefersReducedMotion);

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return;

        const query = window.matchMedia(REDUCED_MOTION_QUERY);
        const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);

        setReduced(query.matches);
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, []);

    return reduced ? 'none' : 'full';
};
